import { styled, Typography } from '@mui/material';

export const Label = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 1
}));
